import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "@/utils/helpers";
import dataService from "../../api";


export default {
    namespaced: true,
    state: {
        departments: [],
        department: {
            name: 'احمد', 
            createdBy: null,
            createdOn: null,
            status: 1,
        },
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.departments.findIndex(i => i.id === id)
    },
    mutations: {
        SET_DEPARTMENTS: (state, data) => state.departments = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SET_DEPARTMENT: (state, viewData) => state.patient = viewData,
        ADD: (state, addedData) => state.departments.unshift(addedData),
        UPDATE: (state, { index, updateData }) => state.departments.splice(index, 1, updateData),
        DELETE: (state, index) => state.departments.splice(index, 1),
    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");

                    const response = await dataService.departments.getAll(paramsString);
                    stopLoading()
                    if (!response.data.statusCode) {
                        showAlert(serverErrorMessage);
                        return;
                    }
        
                commit('SET_DEPARTMENTS', response.data.departments);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async get({ commit }, id) {
            startLoading()
            try {
                commit('SET_DEPARTMENT', {});
                const response = await dataService.departments.getDetails(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
    
                commit('SET_DEPARTMENT', response.data);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getforEdit(_, id) {
            startLoading();
            try {
                
                const response = await dataService.departments.getForEdit(id);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
    
                return Promise.resolve(response.data);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },

        async add({ commit }, payload) {
            // startLoading()
            try {
                // const response = await dataService.departments.add(payload);
                // stopLoading()
                // if (!response.data.statusCode) {
                //     showAlert(serverErrorMessage);
                //     return;
                // }
                // showNotification(response.data.message);

              //  commit('ADD', response.data);
                commit('ADD', payload.name);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async update({ commit, getters }, { id, payload }) {
            startLoading()
            try {
                const response = await dataService.departments.edit(id,payload);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('UPDATE', { index: index, updateData: response.data });

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async delete({ commit, getters }, id) {
            startLoading()
            try {
                // const response = await dataService.departments.delete(id);
                // stopLoading();
                // if (!response.data.statusCode) {
                //     showAlert(serverErrorMessage);
                //     return;
                // }
                // showNotification(response.data.message);

                const index = getters.index(id);
                commit('DELETE', index);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
    },
};
